<template>
  <DefaultLayout class="HomeView">
    <section class="text-center">
      <VImg
        alt="App logo"
        :src="require('../assets/analytics.png')"
        max-width="960px"
        style="margin: 0 auto"
      />
      <KdbArticle
        secret="66334_QIQfI8eDXkJaVjhxDhqXbgiqegzB7APJqU63hzyLBb"
        class="text-center"
      />
    </section>
  </DefaultLayout>
</template>

<script>
import DefaultLayout from '../layouts/Default'
import KdbArticle from '../components/KdbArticle'

export default {
  name: 'Home',
  components: {
    DefaultLayout,
    KdbArticle,
  },
}
</script>
